import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AccountReferrals from "@/pages/account/AccountReferrals";

export const Route = createFileRoute("/account/referrals")({
  head: () => pageHead("Account \u2014 Referrals \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AccountReferrals,
});
